import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ eyebrow, title, lastUpdated, children }) => {
  return (
    <div className="min-h-screen bg-emerald-deep text-[#F5EFE3]">
      {/* Minimal nav */}
      <header className="border-b border-gold/15 bg-emerald-darker/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between gap-6">
          <Link to="/" data-testid="legal-home-link">
            <Logo size="sm" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-btn"
            className="inline-flex items-center gap-2 font-sans tracking-wide-2 text-[0.65rem] uppercase text-[#B0C4B1] hover:text-gold transition"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Natrag
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <span className="font-sans tracking-luxury text-[0.65rem] uppercase text-gold/80">{eyebrow}</span>
        <h1 className="mt-4 font-serif font-light text-4xl md:text-5xl text-[#F5EFE3] leading-[1.1]">{title}</h1>
        <div className="mt-6 sep-gold" />
        {lastUpdated && (
          <p className="mt-6 font-sans text-xs text-[#B0C4B1]/80 tracking-wide-2 uppercase">
            Posljednje ažuriranje: {lastUpdated}
          </p>
        )}

        <article className="mt-12 prose-legal">{children}</article>
      </main>

      <Footer />
    </div>
  );
};
